export * from './floor-space-by-name.pipe';
